export default __webpack_public_path__ + "static/google-de6bbed96395274c5f6e6a83e41cefc7.png";